import React, { useCallback } from "react";

import Button from "devextreme-react/button";
import { ClickEvent } from "devextreme/ui/button";
import { confirm } from "devextreme/ui/dialog";

import { useAppFusion } from "@app/contexts";
import { appNotify, selectUiDrawerItems, setUiDrawer } from "@app/state/units";
import { fxDispatch } from "@app/statefx";
import { appNewInsiderGate } from "@app/statefx/xThunks/app";

import { useAppDispatch, useAppSelector } from "../../state";
import "./drawer.scss";

import type { TConstDrawerPages, TDrawerItem } from "@app/types";
const notifyDanger = appNotify({
  type: "warning",
  message: "SUPER-ADMIN - fii atent, zona serioasa!",
  duration: 5000,
  position: "bottom",
});

const MainDrawerContent = ({
  toggleDrawer,
  currentPage,
}: {
  toggleDrawer: (bool?: boolean) => void;
  currentPage: TConstDrawerPages;
}) => {
  const dispatch = useAppDispatch();
  const { logout } = useAppFusion();
  const drawerItems = useAppSelector(selectUiDrawerItems);

  const dowloadPage = useCallback(() => {
    dispatch(setUiDrawer({ currentPage: "download" }));
  }, []);
  const profilePage = useCallback(() => {
    dispatch(setUiDrawer({ currentPage: "profile" }));
  }, []);

  const swsAdminPage = useCallback(() => {
    dispatch(setUiDrawer({ currentPage: "swsadmin" }));
  }, []);

  const showcasePage = useCallback(() => {
    dispatch(setUiDrawer({ currentPage: "showcase" }));
  }, []);
  const swsBuilderPage = useCallback(() => {
    dispatch(setUiDrawer({ currentPage: "swsbuilder" }));
  }, []);
  const whatsNewPage = useCallback(() => {
    dispatch(setUiDrawer({ currentPage: "whatsnew" }));
  }, []);
  const dologout = useCallback(async () => {
    const result = await confirm(
      "<i>Confirmati iesirea?</i>",
      "Iesire din cont"
    );
    if (result) {
      setTimeout(() => {
        logout();
      }, 300);
    }
  }, []);

  const nop = useCallback(() => {
    /* no op */
  }, []);

  const superAdminHome = useCallback(() => {
    dispatch(notifyDanger);
    dispatch(setUiDrawer({ currentPage: "swsadmin" }));
  }, []);
  const superAdminUsers = useCallback(() => {
    dispatch(notifyDanger);
    dispatch(setUiDrawer({ currentPage: "swsadmin/users" }));
  }, []);
  const superAdminGroups = useCallback(() => {
    dispatch(notifyDanger);
    dispatch(setUiDrawer({ currentPage: "swsadmin/groups" }));
  }, []);
  const swsAdminShowcase = useCallback(() => {
    dispatch(setUiDrawer({ currentPage: "swsadmin/showcase" }));
  }, []);
  const swsInsiders = useCallback((pageCode: string) => {
    fxDispatch(appNewInsiderGate());
    const [_, PERSEED] = pageCode.split("/");
    // set the indexed db name //
    dispatch(setUiDrawer({ currentPage: "insiders", insider: PERSEED }));
  }, []);

  const exchangeRates = useCallback(() => {
    dispatch(setUiDrawer({ currentPage: "swsadmin/exchange" }));
  }, []);

  const itemClick = useCallback((e: ClickEvent) => {
    if (e.element.id.startsWith("insiders/")) {
      toggleDrawer(true);
    } else {
      toggleDrawer(false);
    }
    switch (true) {
      case e.element.id === "download":
        dowloadPage();
        break;
      case e.element.id === "profile":
        profilePage();
        break;
      case e.element.id === "showcase":
        showcasePage();
        break;
      case e.element.id === "logout":
        dologout();
        break;
      case e.element.id === "swsadmin":
        superAdminHome();
        break;
      case e.element.id === "swsadmin/users":
        superAdminUsers();
        break;
      case e.element.id === "swsadmin/groups":
        superAdminGroups();
        break;
      case e.element.id === "swsadmin/showcase":
        swsAdminShowcase();
        break;
      case e.element.id === "whatsnew":
        whatsNewPage();
        break;
      // case e.element.id.startsWith("insiders/"):
      //   {
      //     //we enter the insider zone//
      //     swsInsiders(e.element.id);
      //   }
      //   break;
      // case e.element.id === "swsadmin/exchange":
      //   exchangeRates();
      //   break;
      // case e.element.id === "swsbuilder":
      //   swsBuilderPage();
      //   break;
      default:
        nop();
        break;
    }
  }, []);
  return (
    <div id="drawer-main" className="glass-effect">
      {drawerItems.map((item: TDrawerItem) => {
        return (
          <div key={`keyfor-${item.id}`} className="drawer-item">
            <Button
              id={item.id}
              className={`noIco ${
                currentPage === item.id
                  ? "dx-item-selected"
                  : "dx-item-not-selected"
              } ${item.minCredential === "SWS" ? "danger" : ""}`}
              width={64}
              height={64}
              stylingMode={item.minCredential === "SWS" ? "outlined" : "text"}
              text={item.text}
              onClick={itemClick}
              icon={item.icon}
              visible={item.visible}
              disabled={!item.enabled}
            />
          </div>
        );
      })}
    </div>
  );
};
export default MainDrawerContent;
